import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly fullscreen = signal(false);
  readonly hideSidebar = signal(false);

  setFullscreen(value: boolean) {
    this.fullscreen.set(value);
  }

  toggleFullscreen() {
    this.fullscreen.update((v) => !v);
  }

  setHideSidebar(value: boolean) {
    this.hideSidebar.set(value);
  }
}
